import type { AnalyticDateFilter } from '../../types';
import type { Dayjs } from '~/utils/dayjs';

import { DATE_QUERY_FORMAT } from '../configs';
import { dayjsTz } from '~/utils/dayjs';

const toDate = (value: Dayjs | string): Dayjs =>
  typeof value === 'string' ? dayjsTz(value) : value;

const isMidnight = (date: Dayjs) => date.hour() === 0 && date.minute() === 0;

const formatDateForQuery = (date: Dayjs, isEndDay = false) => {
  if (isEndDay && isMidnight(date)) {
    return date.endOf('day').format(DATE_QUERY_FORMAT);
  }
  return date.format(DATE_QUERY_FORMAT);
};

const getEndOfDayForQuery = (value?: string | Dayjs) => {
  if (!value) {
    return formatDateForQuery(dayjsTz().endOf('day'));
  }
  return formatDateForQuery(dayjsTz(value).endOf('day'));
};

export const getDateRangeForQuery = (dateRange: AnalyticDateFilter) => {
  const startDate = toDate(dateRange.startDate);
  const endDate = toDate(dateRange.endDate);
  const isInTheDay = startDate.isSame(endDate);

  if (isInTheDay) {
    return {
      dateGTE: formatDateForQuery(startDate),
      dateLTE: getEndOfDayForQuery(endDate),
    };
  }

  return {
    dateGTE: formatDateForQuery(startDate),
    dateLTE: formatDateForQuery(endDate, true),
  };
};
